// import { useEffect, useState, useRef } from "react";
// import axios from "axios";
// import styles from "./EmailtemplateeditorTable.module.scss";
// import { oneDark } from "@codemirror/theme-one-dark";

// interface EmailTemplate {
//   _id: string;
//   name: string;
//   userType: string;
//   html: string;
//   createdAt: string;
//   updatedAt: string;
// }

// const EmailTemplateEditorTable: React.FC = () => {
//   const [emailTemplates, setEmailTemplates] = useState<EmailTemplate[]>([]);
//   const [selectedTemplate, setSelectedTemplate] =
//     useState<EmailTemplate | null>(null);
//   const [isTemplateDropdownOpen, setIsTemplateDropdownOpen] = useState(false);
//   const [loading, setLoading] = useState(true);
//   const [htmlCode, setHtmlCode] = useState("");
//   const iframeRef = useRef<HTMLIFrameElement>(null);

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const response = await axios.get(
//           `${process.env.REACT_APP_BASE_URL}/admin/email-templates`
//         );
//         console.log("response is", response.data.data);

//         setEmailTemplates(response.data.data);

//         if (response.data.data.length > 0) {
//           const firstTemplate = response.data.data[0];
//           setSelectedTemplate(firstTemplate);

//           const cleanHtml = firstTemplate.html.replace(/^`|`$/g, "");
//           setHtmlCode(cleanHtml);
//         }
//         setLoading(false);
//       } catch (err) {
//         console.log("error is", err);
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, []);

//   useEffect(() => {
//     if (iframeRef.current && htmlCode) {
//       const iframe = iframeRef.current;
//       const iframeDoc =
//         iframe.contentDocument || iframe.contentWindow?.document;
//       if (iframeDoc) {
//         iframeDoc.open();
//         iframeDoc.write(htmlCode);
//         iframeDoc.close();
//       }
//     }
//   }, [htmlCode]);

//   const handleTemplateSelect = (template: EmailTemplate) => {
//     setSelectedTemplate(template);

//     const cleanHtml = template.html.replace(/^`|`$/g, "");
//     setHtmlCode(cleanHtml);
//     setIsTemplateDropdownOpen(false);
//   };

//   const handleCodeChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
//     setHtmlCode(event.target.value);
//   };

//   if (loading) {
//     return (
//       <div
//         style={{
//           width: "96vw",
//           maxWidth: "96vw",
//           maxHeight: "86vh",
//           height: "86vh",
//           top: "8vh",
//           left: "4vw",
//           position: "relative",
//           backgroundColor: "#EEEEEE",
//           padding: "30px",
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//         }}
//       >
//         <div style={{ fontSize: "18px", color: "#666" }}>
//           Loading email templates...
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div
//       style={{
//         width: "96vw",
//         maxWidth: "96vw",
//         maxHeight: "86vh",
//         height: "86vh",
//         top: "8vh",
//         left: "4vw",
//         overflowY: "auto",
//         position: "relative",
//         backgroundColor: "#EEEEEE",
//         padding: "30px",
//       }}
//     >
//       <div
//         style={{
//           display: "flex",
//           flexDirection: "column",
//           gap: "20px",
//           height: "100%",
//         }}
//       >
//         {/* Header with Template Selector */}
//         <div
//           style={{
//             width: "100%",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//           }}
//         >
//           <h1
//             style={{
//               fontSize: "24px",
//               fontWeight: "600",
//               color: "#333",
//               margin: 0,
//             }}
//           >
//             Email Template Editor
//           </h1>

//           <div style={{ display: "flex", gap: "8px" }}>
//             <div style={{ position: "relative" }}>
//               <div
//                 style={{
//                   borderRadius: "12px",
//                   backgroundColor: "#fff",
//                   padding: "12px 16px",
//                   display: "flex",
//                   gap: "10px",
//                   cursor: "pointer",
//                   minWidth: "250px",
//                   boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
//                   alignItems: "center",
//                   border: "1px solid #e0e0e0",
//                 }}
//                 onClick={() => {
//                   setIsTemplateDropdownOpen(!isTemplateDropdownOpen);
//                 }}
//               >
//                 <span
//                   style={{
//                     color: "#424242",
//                     fontSize: "14px",
//                     flex: "1",
//                     textOverflow: "ellipsis",
//                     overflow: "hidden",
//                     whiteSpace: "nowrap",
//                   }}
//                 >
//                   {selectedTemplate?.name || "Select Template"}
//                 </span>
//                 <span
//                   style={{
//                     fontSize: "14px",
//                     color: "#999",
//                     transform: isTemplateDropdownOpen
//                       ? "rotate(180deg)"
//                       : "rotate(0deg)",
//                     transition: "transform 0.2s ease",
//                   }}
//                 >
//                   ▼
//                 </span>
//               </div>

//               {isTemplateDropdownOpen && (
//                 <div className={styles.dropdownPopup}>
//                   <div className={styles.categoriesList}>
//                     {emailTemplates.map((template) => (
//                       <div
//                         key={template._id}
//                         style={{
//                           padding: "8px 12px",
//                           cursor: "pointer",
//                           borderRadius: "6px",
//                           transition: "background-color 0.2s ease",
//                         }}
//                         className={`${styles.category} ${
//                           selectedTemplate?._id === template._id
//                             ? styles.selectedCategory
//                             : ""
//                         }`}
//                         onClick={() => handleTemplateSelect(template)}
//                         onMouseEnter={(e) => {
//                           if (selectedTemplate?._id !== template._id) {
//                             e.currentTarget.style.backgroundColor = "#f5f5f5";
//                           }
//                         }}
//                         onMouseLeave={(e) => {
//                           if (selectedTemplate?._id !== template._id) {
//                             e.currentTarget.style.backgroundColor =
//                               "transparent";
//                           }
//                         }}
//                       >
//                         <div
//                           style={{
//                             color: "#424242",
//                             fontSize: "14px",
//                             fontWeight: "500",
//                           }}
//                         >
//                           {template.name}
//                         </div>
//                         <div
//                           style={{
//                             color: "#888",
//                             fontSize: "12px",
//                             marginTop: "2px",
//                           }}
//                         >
//                           {template.userType}
//                         </div>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>

//         {/* Editor and Preview Layout */}
//         {selectedTemplate && (
//           <div
//             style={{
//               display: "flex",
//               gap: "20px",
//               height: "calc(100% - 120px)",
//               backgroundColor: "#fff",
//               borderRadius: "12px",
//               padding: "20px",
//               boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
//             }}
//           >
//             {/* Left Side - Code Editor */}
//             <div
//               style={{
//                 flex: "1",
//                 display: "flex",
//                 flexDirection: "column",
//                 minWidth: "0",
//               }}
//             >
//               <h3
//                 style={{
//                   fontSize: "18px",
//                   fontWeight: "600",
//                   color: "#333",
//                   marginBottom: "12px",
//                   marginTop: "0",
//                 }}
//               >
//                 HTML Editor
//               </h3>
//               <textarea
//                 value={htmlCode}
//                 onChange={handleCodeChange}
//                 style={{
//                   flex: "1",
//                   border: "1px solid #e0e0e0",
//                   borderRadius: "8px",
//                   padding: "16px",
//                   fontFamily:
//                     'Consolas, Monaco, "Andale Mono", "Ubuntu Mono", monospace',
//                   fontSize: "14px",
//                   resize: "none",
//                   outline: "none",
//                   backgroundColor: "#fafafa",
//                   lineHeight: "1.5",
//                 }}
//                 placeholder="Edit your HTML template here..."
//               />
//             </div>

//             {/* Right Side - Live Preview */}
//             <div
//               style={{
//                 flex: "1",
//                 display: "flex",
//                 flexDirection: "column",
//                 minWidth: "0",
//               }}
//             >
//               <h3
//                 style={{
//                   fontSize: "18px",
//                   fontWeight: "600",
//                   color: "#333",
//                   marginBottom: "12px",
//                   marginTop: "0",
//                 }}
//               >
//                 Live Preview
//               </h3>
//               <iframe
//                 ref={iframeRef}
//                 style={{
//                   flex: "1",
//                   border: "1px solid #e0e0e0",
//                   borderRadius: "8px",
//                   backgroundColor: "#fff",
//                   width: "100%",
//                 }}
//                 title="Email Template Preview"
//               />
//             </div>
//           </div>
//         )}

//         {/* Template Info */}
//         {selectedTemplate && (
//           <div
//             style={{
//               backgroundColor: "#f8f9fa",
//               padding: "16px",
//               borderRadius: "8px",
//               border: "1px solid #e9ecef",
//               display: "flex",
//               gap: "20px",
//               alignItems: "center",
//               flexWrap: "wrap",
//             }}
//           >
//             <span style={{ fontSize: "14px", color: "#666" }}>
//               <strong>Template ID:</strong> {selectedTemplate._id}
//             </span>
//             <span style={{ fontSize: "14px", color: "#666" }}>
//               <strong>User Type:</strong> {selectedTemplate.userType}
//             </span>
//             <span style={{ fontSize: "14px", color: "#666" }}>
//               <strong>Last Updated:</strong>{" "}
//               {new Date(selectedTemplate.updatedAt).toLocaleDateString()}
//             </span>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default EmailTemplateEditorTable;
import { useEffect, useState, useRef } from "react";
import axios from "axios";
import styles from "./EmailtemplateeditorTable.module.scss";
import { oneDark } from "@codemirror/theme-one-dark";

interface EmailTemplate {
  _id: string;
  name: string;
  userType: string;
  html: string;
  createdAt: string;
  updatedAt: string;
}

const EmailTemplateEditorTable: React.FC = () => {
  const [emailTemplates, setEmailTemplates] = useState<EmailTemplate[]>([]);
  const [selectedTemplate, setSelectedTemplate] =
    useState<EmailTemplate | null>(null);
  const [isTemplateDropdownOpen, setIsTemplateDropdownOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [htmlCode, setHtmlCode] = useState("");
  const [originalHtmlCode, setOriginalHtmlCode] = useState(""); // Track original HTML
  const [isUpdating, setIsUpdating] = useState(false); // Track update status
  const iframeRef = useRef<HTMLIFrameElement>(null);

  // Check if there are unsaved changes
  const hasUnsavedChanges = htmlCode !== originalHtmlCode;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/admin/email-templates`
        );
        console.log("response is", response.data.data);

        setEmailTemplates(response.data.data);

        if (response.data.data.length > 0) {
          const firstTemplate = response.data.data[0];
          setSelectedTemplate(firstTemplate);

          const cleanHtml = firstTemplate.html.replace(/^`|`$/g, "");
          setHtmlCode(cleanHtml);
          setOriginalHtmlCode(cleanHtml); // Set original HTML
        }
        setLoading(false);
      } catch (err) {
        console.log("error is", err);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (iframeRef.current && htmlCode) {
      const iframe = iframeRef.current;
      const iframeDoc =
        iframe.contentDocument || iframe.contentWindow?.document;
      if (iframeDoc) {
        iframeDoc.open();
        iframeDoc.write(htmlCode);
        iframeDoc.close();
      }
    }
  }, [htmlCode]);

  const handleTemplateSelect = (template: EmailTemplate) => {
    setSelectedTemplate(template);

    const cleanHtml = template.html.replace(/^`|`$/g, "");
    setHtmlCode(cleanHtml);
    setOriginalHtmlCode(cleanHtml); // Reset original HTML when selecting new template
    setIsTemplateDropdownOpen(false);
  };

  const handleCodeChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setHtmlCode(event.target.value);
  };

  const handleUpdateTemplate = async () => {
    if (!selectedTemplate || !hasUnsavedChanges) return;

    setIsUpdating(true);
    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_BASE_URL}/admin/email-templates/${selectedTemplate._id}`,
        {
          html: htmlCode,
          name: selectedTemplate.name,
          userType: selectedTemplate.userType,
        }
      );

      if (response.data.success) {
        // Update the original HTML code to reflect the saved state
        setOriginalHtmlCode(htmlCode);

        // Update the template in the list
        setEmailTemplates((prev) =>
          prev.map((template) =>
            template._id === selectedTemplate._id
              ? {
                  ...template,
                  html: htmlCode,
                  updatedAt: new Date().toISOString(),
                }
              : template
          )
        );

        // Update selected template
        setSelectedTemplate((prev) =>
          prev
            ? { ...prev, html: htmlCode, updatedAt: new Date().toISOString() }
            : null
        );

        console.log("Template updated successfully");
        // You can add a toast notification here
      }
    } catch (error) {
      console.error("Error updating template:", error);
      // You can add error handling/toast notification here
    } finally {
      setIsUpdating(false);
    }
  };

  const handleUndoChanges = () => {
    setHtmlCode(originalHtmlCode);
  };

  if (loading) {
    return (
      <div
        style={{
          width: "96vw",
          maxWidth: "96vw",
          maxHeight: "86vh",
          height: "86vh",
          top: "8vh",
          left: "4vw",
          position: "relative",
          backgroundColor: "#EEEEEE",
          padding: "30px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ fontSize: "18px", color: "#666" }}>
          Loading email templates...
        </div>
      </div>
    );
  }

  return (
    <div
      style={{
        width: "96vw",
        maxWidth: "96vw",
        maxHeight: "86vh",
        height: "86vh",
        top: "8vh",
        left: "4vw",
        overflowY: "auto",
        position: "relative",
        backgroundColor: "#EEEEEE",
        padding: "30px",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "20px",
          height: "100%",
        }}
      >
        {/* Header with Template Selector */}
        <div
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <h1
            style={{
              fontSize: "24px",
              fontWeight: "600",
              color: "#333",
              margin: 0,
            }}
          >
            Email Template Editor
          </h1>

          <div style={{ display: "flex", gap: "8px" }}>
            <div style={{ position: "relative" }}>
              <div
                style={{
                  borderRadius: "12px",
                  backgroundColor: "#fff",
                  padding: "12px 16px",
                  display: "flex",
                  gap: "10px",
                  cursor: "pointer",
                  minWidth: "250px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                  alignItems: "center",
                  border: "1px solid #e0e0e0",
                }}
                onClick={() => {
                  setIsTemplateDropdownOpen(!isTemplateDropdownOpen);
                }}
              >
                <span
                  style={{
                    color: "#424242",
                    fontSize: "14px",
                    flex: "1",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                  }}
                >
                  {selectedTemplate?.name || "Select Template"}
                </span>
                <span
                  style={{
                    fontSize: "14px",
                    color: "#999",
                    transform: isTemplateDropdownOpen
                      ? "rotate(180deg)"
                      : "rotate(0deg)",
                    transition: "transform 0.2s ease",
                  }}
                >
                  ▼
                </span>
              </div>

              {isTemplateDropdownOpen && (
                <div className={styles.dropdownPopup}>
                  <div className={styles.categoriesList}>
                    {emailTemplates.map((template) => (
                      <div
                        key={template._id}
                        style={{
                          padding: "8px 12px",
                          cursor: "pointer",
                          borderRadius: "6px",
                          transition: "background-color 0.2s ease",
                        }}
                        className={`${styles.category} ${
                          selectedTemplate?._id === template._id
                            ? styles.selectedCategory
                            : ""
                        }`}
                        onClick={() => handleTemplateSelect(template)}
                        onMouseEnter={(e) => {
                          if (selectedTemplate?._id !== template._id) {
                            e.currentTarget.style.backgroundColor = "#f5f5f5";
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (selectedTemplate?._id !== template._id) {
                            e.currentTarget.style.backgroundColor =
                              "transparent";
                          }
                        }}
                      >
                        <div
                          style={{
                            color: "#424242",
                            fontSize: "14px",
                            fontWeight: "500",
                          }}
                        >
                          {template.name}
                        </div>
                        {/* <div
                          style={{
                            color: "#888",
                            fontSize: "12px",
                            marginTop: "2px",
                          }}
                        >
                          {template.userType}
                        </div> */}
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Editor and Preview Layout */}
        {selectedTemplate && (
          <div
            style={{
              display: "flex",
              gap: "20px",
              height: "calc(100% - 120px)",
              backgroundColor: "#fff",
              borderRadius: "12px",
              padding: "20px",
              boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
            }}
          >
            {/* Left Side - Code Editor */}
            <div
              style={{
                flex: "1",
                display: "flex",
                flexDirection: "column",
                minWidth: "0",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "12px",
                }}
              >
                <h3
                  style={{
                    fontSize: "18px",
                    fontWeight: "600",
                    color: "#333",
                    margin: "0",
                  }}
                >
                  HTML Editor
                </h3>

                {/* Action Buttons */}
                {hasUnsavedChanges && (
                  <div style={{ display: "flex", gap: "8px" }}>
                    <button
                      onClick={handleUndoChanges}
                      style={{
                        padding: "8px 16px",
                        backgroundColor: "#f5f5f5",
                        border: "1px solid #ddd",
                        borderRadius: "6px",
                        cursor: "pointer",
                        fontSize: "14px",
                        color: "#666",
                        transition: "all 0.2s ease",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = "#e9e9e9";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = "#f5f5f5";
                      }}
                    >
                      Undo Changes
                    </button>
                    <button
                      onClick={handleUpdateTemplate}
                      disabled={isUpdating}
                      style={{
                        padding: "8px 16px",
                        backgroundColor: isUpdating ? "#ccc" : "#007bff",
                        border: "none",
                        borderRadius: "6px",
                        cursor: isUpdating ? "not-allowed" : "pointer",
                        fontSize: "14px",
                        color: "#fff",
                        fontWeight: "500",
                        transition: "all 0.2s ease",
                      }}
                      onMouseEnter={(e) => {
                        if (!isUpdating) {
                          e.currentTarget.style.backgroundColor = "#0056b3";
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (!isUpdating) {
                          e.currentTarget.style.backgroundColor = "#007bff";
                        }
                      }}
                    >
                      {isUpdating ? "Updating..." : "Update Template"}
                    </button>
                  </div>
                )}
              </div>

              <textarea
                value={htmlCode}
                onChange={handleCodeChange}
                style={{
                  flex: "1",
                  border: "1px solid #e0e0e0",
                  borderRadius: "8px",
                  padding: "16px",
                  fontFamily:
                    'Consolas, Monaco, "Andale Mono", "Ubuntu Mono", monospace',
                  fontSize: "14px",
                  resize: "none",
                  outline: "none",
                  backgroundColor: "#fafafa",
                  lineHeight: "1.5",
                }}
                placeholder="Edit your HTML template here..."
              />
            </div>

            {/* Right Side - Live Preview */}
            <div
              style={{
                flex: "1",
                display: "flex",
                flexDirection: "column",
                minWidth: "0",
              }}
            >
              <h3
                style={{
                  fontSize: "18px",
                  fontWeight: "600",
                  color: "#333",
                  marginBottom: "12px",
                  marginTop: "0",
                }}
              >
                Live Preview
              </h3>
              <iframe
                ref={iframeRef}
                style={{
                  flex: "1",
                  border: "1px solid #e0e0e0",
                  borderRadius: "8px",
                  backgroundColor: "#fff",
                  width: "100%",
                }}
                title="Email Template Preview"
              />
            </div>
          </div>
        )}

        {/* Template Info */}
        {/* {selectedTemplate && (
          <div
            style={{
              backgroundColor: "#f8f9fa",
              padding: "16px",
              borderRadius: "8px",
              border: "1px solid #e9ecef",
              display: "flex",
              gap: "20px",
              alignItems: "center",
              flexWrap: "wrap",
            }}
          >
            <span style={{ fontSize: "14px", color: "#666" }}>
              <strong>Template ID:</strong> {selectedTemplate._id}
            </span>
            <span style={{ fontSize: "14px", color: "#666" }}>
              <strong>User Type:</strong> {selectedTemplate.userType}
            </span>
            <span style={{ fontSize: "14px", color: "#666" }}>
              <strong>Last Updated:</strong>{" "}
              {new Date(selectedTemplate.updatedAt).toLocaleDateString()}
            </span>
            {hasUnsavedChanges && (
              <span
                style={{
                  fontSize: "14px",
                  color: "#e75b4d",
                  fontWeight: "bold",
                }}
              >
                • Unsaved Changes
              </span>
            )}
          </div>
        )} */}
      </div>
    </div>
  );
};

export default EmailTemplateEditorTable;
